import types from '../../actions/types'
import { combineReducers } from 'redux'

export const visible = (state = false, action) => {
  switch (action.type) {
    case types.PRICE_LISTS_SHOW_ADD_PACK_DIALOG: return true
    case types.PRICE_LISTS_HIDE_ADD_PACK_DIALOG: return false
    default:
      return state
  }
}

export default combineReducers({
  visible,
})